import React from "react";
import * as att from "../../common/attestationStatus";

const AttestationStatusComp = (props)=>{
    
    let statusClass = "status";
    switch (props.status.toLowerCase()) {
       case att.CompletedStatus:
       case att.ReviewedStatus:
        statusClass = `${statusClass} status-green`;
        break;
       case 'sent':
        statusClass = `${statusClass} status-green`;
        break;
       case att.UnopenedStatus:
        statusClass = `${statusClass} status-purple`;
        break;
       case att.ReviewingStatus:
        statusClass = `${statusClass} status-orange`;
        break;
       case att.WithdrawnStatus:
        statusClass = `${statusClass} status-grey`;
        break;
    }

    return(
        <span className={statusClass}>{props.children}</span>
    )
};

export default AttestationStatusComp;

